// Generated by ReScript, PLEASE EDIT WITH CARE


function getDNName(country) {
  if (country.TAG === /* India */1) {
    return "Receiving copy";
  } else {
    return "Delivery note";
  }
}

function getDNNameCaps(country) {
  if (country.TAG === /* India */1) {
    return "Receiving Copy";
  } else {
    return "Delivery Note";
  }
}

function getDNNameSmall(country) {
  if (country.TAG === /* India */1) {
    return "receiving copy";
  } else {
    return "delivery note";
  }
}

export {
  getDNName ,
  getDNNameCaps ,
  getDNNameSmall ,
  
}
/* No side effect */
